var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$tc('hr.label')))]),_c('v-card-subtitle',[_vm._v("2021-2022")]),_c('v-card-text',[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.items,"items-per-page":-1,"hide-default-footer":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }